import { AxiosRequestConfig } from 'axios'
import { AuthLocalStoragerEnum } from 'experiments/StaffLink/StaffLink.constants'
import { isDev } from 'infra/environment'
import { getBusinessId, isWebView } from 'utils/android'

export const injectAuthToken = (config: AxiosRequestConfig) => {
  const token = getAndroidToken() || localStorage?.get(AuthLocalStoragerEnum.staffLinkAccessToken)
  config.headers.Authorization = token ? `Bearer ${token}` : ''
  config.headers['OKC-Business-Id'] = getBusinessId() || ''
  config.headers['ngrok-skip-browser-warning'] = '69420'
}

/**
 * Wait for android injection to complete.
 * @returns Promise<number>
 */
export const waitForInjection = (): Promise<number> => {
  return new Promise((resolve) => {
    const counter = setInterval(() => {
      if (isDev || !isWebView()) {
        clearInterval(counter)
        resolve(0)
      } else {
        if (window.androidObj) {
          if (
            window.androidObj.isAuthV3 ||
            window.androidObj.getBusinessId ||
            window.androidObj.getAuthToken
          ) {
            clearInterval(counter)
            resolve(0)
          }
        }
      }
    }, 300)
  })
}

/**
 * Get the auth token for bearer
 * @returns string | null
 */
export const getAndroidToken = (): string | null => {
  try {
    if (typeof window !== 'undefined') {
      if (window.androidObj && window.androidObj.getAuthToken) {
        return window.androidObj.getAuthToken()
      }
    }
  } catch (e) {
    console.log('isWeb2')
    return null
  }
  return null
}
